/**
 * Khi API lịch sử không trả question_results (worker/DB cũ hoặc cột result_detail trống),
 * vẫn hiển thị chi tiết nhờ snapshot lưu tại trình duyệt ngay sau khi nộp bài thành công.
 */

const LS_BY_ID = 'eduquiz_result_detail_by_id_v1';
const LS_SNAPS = 'eduquiz_submit_snapshots_v1';
const MAX_BY_ID = 120;
const MAX_SNAPS = 40;

function safeParse(raw) {
  try {
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

function pruneIdMap(map) {
  const entries = Object.entries(map);
  if (entries.length <= MAX_BY_ID) return map;
  entries.sort((a, b) => (Number(b[1]?.savedAt) || 0) - (Number(a[1]?.savedAt) || 0));
  const next = {};
  entries.slice(0, MAX_BY_ID).forEach(([k, v]) => {
    next[k] = v;
  });
  return next;
}

/**
 * Gọi sau POST submit thành công (PublicQuizPlayPage).
 * @param {object} p
 * @param {number|string|undefined} p.quizResultId — meta.last_row_id từ worker (nếu có)
 * @param {string} p.quizId
 * @param {number} p.score
 * @param {number} p.correct_answers
 * @param {number} p.total_questions
 * @param {boolean} p.passed
 * @param {number} p.pass_score
 * @param {object[]} p.question_results
 */
export function recordQuizSubmitForHistory(p) {
  const qr = Array.isArray(p?.question_results) ? p.question_results : [];
  if (qr.length === 0) return;

  const payload = {
    question_results: qr,
    passed: Boolean(p.passed),
    pass_score: Number(p.pass_score ?? 70),
    savedAt: Date.now(),
  };

  try {
    if (p.quizResultId != null && p.quizResultId !== '') {
      const raw = localStorage.getItem(LS_BY_ID);
      const map = safeParse(raw) || {};
      map[String(p.quizResultId)] = payload;
      localStorage.setItem(LS_BY_ID, JSON.stringify(pruneIdMap(map)));
    }
  } catch {
    /* ignore */
  }

  try {
    const raw = localStorage.getItem(LS_SNAPS);
    const list = Array.isArray(safeParse(raw)) ? safeParse(raw) : [];
    const key = `${Date.now()}_${Math.random().toString(36).slice(2, 9)}`;
    list.unshift({
      key,
      quizId: String(p.quizId || ''),
      score: Number(p.score ?? 0),
      correctAnswers: Number(p.correct_answers ?? 0),
      totalQuestions: Number(p.total_questions ?? 0),
      passed: Boolean(p.passed),
      pass_score: Number(p.pass_score ?? 70),
      clientReceivedAt: Date.now(),
      question_results: qr,
    });
    localStorage.setItem(LS_SNAPS, JSON.stringify(list.slice(0, MAX_SNAPS)));
  } catch {
    /* ignore */
  }
}

function getByResultId(id) {
  if (id == null || id === '') return null;
  try {
    const map = safeParse(localStorage.getItem(LS_BY_ID));
    if (!map || typeof map !== 'object') return null;
    return map[String(id)] || null;
  } catch {
    return null;
  }
}

function loadSnapshots() {
  const list = safeParse(localStorage.getItem(LS_SNAPS));
  return Array.isArray(list) ? list : [];
}

function snapshotsMatchRow(snap, row) {
  return (
    String(snap.quizId) === String(row.quiz_id) &&
    Number(snap.score) === Number(row.score) &&
    Number(snap.correctAnswers) === Number(row.correct_answers) &&
    Number(snap.totalQuestions) === Number(row.total_questions) &&
    Math.abs(Number(row.timestamp) - Number(snap.clientReceivedAt)) < 12 * 60 * 1000
  );
}

/**
 * @param {object[]} rows — items từ GET quiz-results
 * @returns {object[]} bản sao đã ghép question_results / passed khi có snapshot
 */
export function enrichQuizHistoryRows(rows) {
  if (!Array.isArray(rows)) return [];
  const snaps = loadSnapshots();
  const usedKeys = new Set();

  return rows.map((row) => {
    let question_results = Array.isArray(row.question_results) ? [...row.question_results] : [];
    let passed = row.passed;

    if (question_results.length === 0) {
      const byId = getByResultId(row.id);
      if (byId?.question_results?.length) {
        question_results = byId.question_results;
        passed = byId.passed ?? passed;
      }
    }

    if (question_results.length === 0) {
      const snap = snaps.find((s) => !usedKeys.has(s.key) && snapshotsMatchRow(s, row));
      if (snap?.question_results?.length) {
        usedKeys.add(snap.key);
        question_results = snap.question_results;
        passed = snap.passed ?? passed;
      }
    }

    return {
      ...row,
      question_results,
      passed,
    };
  });
}
